/*
 * @Autor: dingxiaolin
 * @Date: 2021-02-05 14:11:43
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2023-05-10 10:56:43
 */
import { default as PaginationPanel } from './PaginationPanel.vue';
import { default as SearchPanel } from './SearchPanel.vue';
import { default as DataPanel } from './DataPanel.vue';
import { default as updateFile } from './updateFile.vue';

import { default as headPanel } from './headPanel.vue';
import { default as NumberKeyboardNew } from './NumberKeyboardNew.vue';
import { default as newNumberKeyboard } from './newNumberKeyboard.vue';
import { default as padHeadPanel } from './pad/headPanel.vue';
import { default as padHeadPanel2 } from './pad/headPanel2.vue';
import { default as logoutPanel } from './pad/logoutPanel.vue';
import { default as calendarPanel } from './pad/calendarPanel.vue';
import { default as classList } from './pad/classList.vue';
import { default as dialogPanel } from './pad/dialogPanel.vue';
import { default as addClassPanel } from './pad/addClassPanel.vue';
import { default as sortPanel } from './pad/sortPanel.vue';
import { default as padHeadPanel3 } from './pad/headPanel3.vue';
import { default as productUnitPanel } from './pad/productUnitPanel.vue';
import { default as selectClassPanel } from './pad/selectClassPanel.vue';
import { default as NumberKeyboard } from './pad/NumberKeyboard.vue';
import { default as selectSpecsPanel } from './pad/selectSpecsPanel.vue';
import { default as addSpecsPanel } from './pad/addSpecsPanel.vue';
import { default as supplierPanel } from './pad/supplierPanel.vue';
import { default as addSupplierPanel } from './pad/addSupplierPanel.vue';
import { default as selectAddressPanel } from './pad/selectAddressPanel.vue';
import { default as vipGradePanel } from './pad/vipGradePanel.vue';
import { default as birthdayPanel } from './pad/birthdayPanel.vue';
import { default as changeBalancePanel } from './pad/changeBalancePanel.vue';
import { default as changeScorePanel } from './pad/changeScorePanel.vue';
import { default as batchSettings } from './pad/batchSettings.vue';
import { default as counter } from './pad/counter.vue';
import { default as NumberKeyboard1 } from './pad/NumberKeyboard1.vue';
import { default as logoutPanel1 } from './pad/logoutPanel1.vue';
import { default as printLabelPanel } from './pad/printLabelPanel.vue';
import { default as openingPrompt } from './pad/openingPrompt.vue';
import { default as versionSpecsPanel } from './pad/versionSpecsPanel.vue';
import { default as padHeadPanel4 } from './pad/headPanel4.vue';
import { default as imageDialog } from './pad/imageDialog.vue';
import { default as addByjPanel } from './pad/addByjPanel.vue';

export {
    PaginationPanel,
    SearchPanel,
    DataPanel,
    updateFile,

    headPanel, NumberKeyboardNew, newNumberKeyboard, padHeadPanel, logoutPanel, padHeadPanel2, calendarPanel, classList, dialogPanel, addClassPanel, sortPanel, padHeadPanel3,
    productUnitPanel, selectClassPanel, NumberKeyboard, selectSpecsPanel, addSpecsPanel, supplierPanel, addSupplierPanel, selectAddressPanel, vipGradePanel, birthdayPanel,
    changeBalancePanel, changeScorePanel, batchSettings, counter, NumberKeyboard1, logoutPanel1, printLabelPanel, openingPrompt, versionSpecsPanel, padHeadPanel4,
    imageDialog,addByjPanel


};



// WEBPACK FOOTER //
// ./src/components/index.ts